(function () {
  'use strict';

  function getCurrentVariantId(fallbackVariantId) {
    var picker = document.querySelector('variant-picker[data-main-product="true"]');
    var variantId = picker && picker.dataset.currentVariantId;
    if (variantId && String(variantId).length > 0) {
      return variantId;
    }
    return fallbackVariantId;
  }

  window.openTearSheet = function (productUrl, fallbackVariantId) {
    if (!productUrl) {
      return;
    }
    var variantId = getCurrentVariantId(fallbackVariantId);
    var url = productUrl + '?view=tear-sheet&variant=' + variantId;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  function initTearSheetTriggers() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.social-sharing__tear-sheet-trigger');
      if (!trigger) {
        return;
      }
      event.preventDefault();
      window.openTearSheet(trigger.dataset.productUrl, trigger.dataset.variantId);
    });
  }

  function initTearSheetPrint() {
    var root = document.getElementById('tear-sheet-print');
    if (!root) {
      return;
    }

    var absoluteUrl = root.dataset.productUrl || '';
    var showQr = root.dataset.showQr === 'true';
    var locale = root.dataset.locale || undefined;
    var autoPrint = root.dataset.autoPrint === 'true';
    var autoClose = root.dataset.autoClose === 'true';

    var dateEl = document.getElementById('tear-sheet-date');
    if (dateEl) {
      dateEl.textContent = new Date().toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }

    if (showQr && typeof QRious !== 'undefined') {
      var canvas = document.getElementById('tear-sheet-qr');
      if (canvas) {
        new QRious({
          element: canvas,
          value: absoluteUrl,
          size: 200,
          level: 'H'
        });
      }
    }

    if (autoPrint) {
      window.addEventListener('load', function () {
        window.print();
        if (autoClose) {
          window.setTimeout(function () {
            window.close();
          }, 3000);
        }
      });
    }
  }

  initTearSheetTriggers();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTearSheetPrint);
  } else {
    initTearSheetPrint();
  }
})();
